import React from 'react';
import './Modal.css';

const Modal = ({ open, onClose, founder }) => {
  if (!open) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        
        <div className="modal-body">
          <div className="profile-left">
            <img src={founder.img} alt={founder.name} className="profile-img" />
            <div className="profile-info">
              <h3 className="founder-name">{founder.name}</h3>
              <p className="founder-role">{founder.role}</p>
            </div>
          </div>

          <div className="profile-right">
            <div className="cv-section">
              <h4>{founder.titles[0]}</h4>
              <p dangerouslySetInnerHTML={{ __html: founder.bio }}/>
            </div>

            <div className="cv-section">
              <h4>{founder.titles[1]}</h4>
              <p dangerouslySetInnerHTML={{ __html: founder.practiceAreas }}/>
            </div>

            <div className="cv-section">
              <h4>{founder.titles[2]}</h4>
              <p dangerouslySetInnerHTML={{ __html: founder.education }}/>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Modal;
